import { render } from "./EliminaCollo.vue?vue&type=template&id=28f28c1a&scoped=true"
import script from "./EliminaCollo.vue?vue&type=script&lang=js"
export * from "./EliminaCollo.vue?vue&type=script&lang=js"

import "./EliminaCollo.vue?vue&type=style&index=0&id=28f28c1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f28c1a"]])

export default __exports__